import { setCookie } from "@/utils/cookie";
export default {
  namespaced: true,
  state: () => ({
    user: {},
    countdownCounter: "",
    countdownTime: 0,
    mobilePhone: "",
  }),
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    resetUser(state) {
      state.user = {};
      setCookie("Authorization", "");
    },
    countdown(state) {
      state.countdownTime -= 1;
    },
    setcountdownTime(state) {
      state.countdownTime = 60;
    },
    setCountdownCounter(state, countdownCounter) {
      state.countdownCounter = countdownCounter;
    },
    setMobilePhone(state, payload) {
      state.mobilePhone = payload;
    },
  },
  actions: {
    countdown({ state, commit, dispatch }) {
      if (!state.countdownTime) {
        if (state.countdownCounter) {
          clearTimeout(state.countdownCounter);
          commit("setCountdownCounter", "");
        } else {
          commit("setcountdownTime");
          commit(
            "setCountdownCounter",
            setTimeout(() => {
              dispatch("countdown");
            }, 1000)
          );
        }
      } else {
        commit("countdown");
        clearTimeout(state.countdownCounter);
        state.countdownCounter = setTimeout(() => {
          dispatch("countdown");
        }, 1000);
      }
    },
  },
};
